const timeOnlyHelper = {
	time(date: Date, omitSeconds?: boolean) : string {
		const h = date.getHours();
		const m = date.getMinutes();

		const hours = h < 10 ? `0${h}` : h + '';
		const minutes = m < 10 ? `0${m}` : m + '';
		
		if (omitSeconds) {
			return `${hours}:${minutes}:00`;
		} else {
			const s = date.getSeconds();
			const seconds = s < 10 ? `0${s}` : s + '';
			return `${hours}:${minutes}:${seconds}`;
		}
	},

	nowTime() {
		return this.time(new Date());
	},

	toDate(dateOnly?: string, timeOnly?: string) : Date {
		if (!dateOnly ||
			!timeOnly) {
			return new Date();
		}

		const dateSplitter = '-', timeSplitter = ':';
		const [hours, minutes, seconds] = timeOnly.split(timeSplitter).map(Number);
		const [year, month, date] = dateOnly.split(dateSplitter).map(Number);

		return new Date(year, month-1, date, hours, minutes, seconds);
	},
	
	/**
	 * Converts to Local time from utc-pair DateOnly+TimeOnly
	 * @param dateOnly '2025-12-31'
	 * @param timeOnly '10:30:59'
	 */
	toLocalTime(dateOnly: string | null, timeOnly: string | null) : string {

		if (!dateOnly ||
			!timeOnly) {
			return '';
		}

		const offsetMilliseconds = new Date().getTimezoneOffset() * 60 * 1000;		

		const utcDateTime = this.toDate(dateOnly, timeOnly);
		const localDateTime = new Date(utcDateTime.getTime() - offsetMilliseconds);
		const localTimeOnly = this.time(localDateTime);

		return localTimeOnly;
	},

	/**
	 * Converts to UTC time from pair DateOnly+TimeOnly
	 * @param dateOnly '2025-12-31'
	 * @param timeOnly '10:30:59'
	 */
	toUtcTime(dateOnly: string | null, timeOnly: string | null) : string {
		if (!dateOnly ||
			!timeOnly) {
			return '';
		}

		const dateTime = this.toDate(dateOnly, timeOnly);
		const offsetMilliseconds = new Date().getTimezoneOffset() * 60 * 1000;

		const utcDateTime = new Date(dateTime.getTime() + offsetMilliseconds);
		const utcTimeOnly = this.time(utcDateTime);

		return utcTimeOnly;
	}
}
export default timeOnlyHelper;